export default __webpack_public_path__ + "static/media/FID_guide.3c6c21d5.png";